<template>
<div id="orderQuery">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'orderQuery'
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/orderQuery/index.vue